var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmptyYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48.0 48.0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2,0 L25.08,12 L38.4,13.92 L28.92,22.92 L31.2,36.48 L19.2,30.24 L7.2,36.48 L9.48,22.92 L0,13.92 L13.32,12 L19.2,0 Z M19.2,5.4 L14.88,14.16 L5.16,15.6 L12,22.08 L10.44,32.04 L19.2,27.48 L27.96,32.04 L26.4,22.08 L33.24,15.6 L23.52,14.16 L19.2,5.4 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.800000000000001 4.32)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 38.4,0 38.4,36.48 0,36.48 0,0",
    stroke: "none",
    fill: "#1700F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmptyYellow);
export default __webpack_public_path__ + "static/media/star-empty-yellow.fea3ef26d41ea2c446a29e7fe83f5e09.svg";
export { ForwardRef as ReactComponent };